export function* devicesGenerator(devices) {
  let currentDeviceIndex = -1;
  let oneOrNoDevicesLeft = false;

  while (true) {
    currentDeviceIndex += 1;

    if (oneOrNoDevicesLeft === true) {
      return devices[currentDeviceIndex];
    }

    if (currentDeviceIndex >= devices.length) {
      currentDeviceIndex = 0;
    }

    const previousFailed = yield devices[currentDeviceIndex];

    if (previousFailed === true) {
      devices.splice(currentDeviceIndex, 1);
      currentDeviceIndex -= 1;
    }

    if (devices.length < 2) {
      oneOrNoDevicesLeft = true;
    }
  }
}
